import React from "react";
import { DashTransactionsResponse } from "../ceo-dashboard.service";

interface FundSubscriptionsCardsProps {
  transactionsData: DashTransactionsResponse | null;
  loading: boolean;
}

const FundSubscriptionsCards: React.FC<FundSubscriptionsCardsProps> = ({
  transactionsData,
  loading,
}) => {
  // Default funds with their details
  const defaultFunds = [
    {
      name: "Kamco Investment Fund",
      color: "#7086FD",
      icon: "/images/fund-investment.svg",
      shortName: "Investment",
    },
    {
      name: "Kamco Islamic Fund",
      color: "#6FD195",
      icon: "/images/fund-islamic.svg",
      shortName: "Islamic",
    },
    {
      name: "Kamco Premier Market Index Fund",
      color: "#FFAE4C",
      icon: "/images/fund-premier.svg",
      shortName: "Premier",
    },
  ];

  // Get total subscriptions by fund from subscriptionBreakdown
  const getFundTotal = (fundName: string) => {
    if (!transactionsData?.data?.subscriptionBreakdown) {
      return 0;
    }

    // Find subscription breakdown for this fund and sum the amounts
    const matchingBreakdowns = transactionsData.data.subscriptionBreakdown
      .filter((breakdown) => {
        // Normalize both strings for comparison
        const fundNameNormalized = fundName.toLowerCase().trim();
        const breakdownNameNormalized = breakdown.fundNameEn.toLowerCase().trim();

        // Try multiple matching strategies
        const matches = (
          // Exact match
          fundNameNormalized === breakdownNameNormalized ||
          // Contains match (either direction)
          fundNameNormalized.includes(breakdownNameNormalized) ||
          breakdownNameNormalized.includes(fundNameNormalized) ||
          // Match key words (Islamic, Investment, Premier)
          (fundNameNormalized.includes('islamic') && breakdownNameNormalized.includes('islamic')) ||
          (fundNameNormalized.includes('investment') && breakdownNameNormalized.includes('investment')) ||
          (fundNameNormalized.includes('premier') && breakdownNameNormalized.includes('premier'))
        );

        return matches;
      });

    const total = matchingBreakdowns.reduce((sum, breakdown) => sum + breakdown.total, 0);
    return total;
  };

  return (
    <div className="w-full lg:w-[30rem] flex flex-col justify-start items-start gap-5 lg:h-[420px]">
      {defaultFunds.map((fund, index) => {
        const total = getFundTotal(fund.name);

        return (
          <div
            key={index}
            className="w-full p-4 bg-white rounded-lg inline-flex flex-col justify-between items-start shadow-md flex-1"
          >
            <div className="self-stretch inline-flex justify-between items-start">
              <div className="flex-1 inline-flex flex-col justify-start items-start gap-3.5">
                <div className="self-stretch opacity-70 justify-start text-neutral-800 text-xs font-semibold">
                  {fund.shortName} Fund
                </div>
                <div className="self-stretch justify-start">
                  <span className="text-zinc-800 text-2xl font-bold tracking-wide">
                    {loading ? "Loading..." : total.toLocaleString()}{" "}
                  </span>
                  <span className="text-zinc-800 text-base font-semibold tracking-wide">
                    KWD
                  </span>
                </div>
              </div>
            </div>
            <div className="self-stretch flex justify-between items-center mt-2">
              <div className="text-xs text-gray-700 font-['Montserrat'] truncate">
                {fund.name}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FundSubscriptionsCards;
